import PaginaPrincipal from "pages/pagina-principal/pagina-principal.page";

const routes = [
  {
    path: `${process.env.PUBLIC_URL}/`,
    component: PaginaPrincipal
  }
];
export default routes;